export class SubcategoryHistory {

    public id: string = "0";
    public member_id: string;
    public member_name: string;
    public date: Date;
    public subcategory_id: string;
    public subcategory_name: string;
    public subcategory_annuity: boolean;
    public annuity_from: number;
    public flag: boolean


    constructor() {}
}